import DefaultModelResolver from "./modelResolvers/default.modelResolver";

export { Client } from "./client";

export const modelResolvers = {
	DefaultModelResolver,
};
